<template>
  <div class="slide-show" ref="slideHeight">
    <swiper :options="swiperOption">
      <swiper-slide class="sli" v-for="(item,index) in slides" :key="index" @click.native="goParam(index)">
        <img :src="item.src" alt/>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  name: "SlideShow",
  data() {
    return {
      nowIndex: 0,
      isShow: true,
      invTime: 3000,
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable :true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        }
      },
      slides: [
        {
          src:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/slideShow/bannervci.png"
        },
        {
          src:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/slideShow/banner_control.png"
        },
        {
          src:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/slideShow/bannerCost.png"
        },
        {
          src:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/slideShow/bannerVc.png"
        }
      ]
    };
  },
  methods: {
    goParam(nowIndex) {
      if (nowIndex === 0) {
        this.$router.push("/products/cloudDesktop");
      }
    }
  }
};
</script>

<style scoped>
.slide-show {
  position: relative;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}

.slide-img {
  width: 100%;
}

.slide-img img {
  width: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.slide-img img:first-child {
  position: relative;
}

.slide-pages {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-70px);
}

.slide-pages li {
  width: 14px;
  height: 14px;
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  border-radius: 7px;
  display: inline-block;
  margin: 0 10px;
  cursor: pointer;
  background: transparent;
  border: 2px solid #f39800;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.slide-pages li.on {
  background: #fff;
  border: transparent;
}

.bannerTitle {
  position: absolute;
  top: 23%;
  left: 25%;
  color: #fff;
  font-size: 36px;
}

.bannerText {
  position: absolute;
  top: 35%;
  left: 25%;
  color: #fff;
  font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/SlideShow.vue